module.exports = __webpack_public_path__ + "static/media/front@2x.ead32677.png";